import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import {Box, Button} from '@mui/material'
import React from 'react'

type NavigationButtonProps = {
  onClick: () => void
  icon: React.ReactNode
  disabled?: boolean
  position: 'left' | 'right'
  dataTestId: string
}

const UndefinedStoppagesNavigationButton: React.FC<NavigationButtonProps> = ({
  onClick,
  icon,
  disabled,
  position,
  dataTestId
}) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    startIcon={icon}
    size="small"
    variant="text"
    sx={{
      minWidth: '40px',
      padding: 1,
      borderRadius: 0.5,
      backgroundColor: 'grey.200',
      position: 'absolute',
      [position]: 0,
      '& .MuiButton-startIcon': {margin: 0},
      '&:hover': {backgroundColor: 'grey.300', border: 'none'}
    }}
    data-test-id={dataTestId}
  />
)

type Props = {
  onPrev: () => void
  onNext: () => void
  prevDisabled?: boolean
  nextDisabled?: boolean
  showPrev: boolean
  showNext: boolean
}

export const UndefinedStoppagesPrevNextButtons: React.FC<Props> = ({
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
  showPrev,
  showNext
}) => {
  if (!showPrev && !showNext) {
    return null
  }
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="end"
      sx={{
        width: '70%',
        height: '0',
        marginLeft: '-10%',
        position: 'fixed',
        top: '54%'
      }}
    >
      {showPrev && (
        <UndefinedStoppagesNavigationButton
          onClick={onPrev}
          disabled={prevDisabled}
          icon={<ArrowBackIosNewIcon sx={{color: 'grey.600'}} />}
          position="left"
          dataTestId="prev-stoppage-button"
        />
      )}
      {showNext && (
        <UndefinedStoppagesNavigationButton
          onClick={onNext}
          disabled={nextDisabled}
          icon={<ArrowForwardIosIcon sx={{color: 'grey.600'}} />}
          position="right"
          dataTestId="next-stoppage-button"
        />
      )}
    </Box>
  )
}
